import React, { useState, useEffect } from "react";
import VerPlanSiembra from "./PlanSimebraComponents/VerPlanSiembra";
import CargarExcel from "./PlanSimebraComponents/CargarExel";
import HistorialDeCargas from "./PlanSimebraComponents/HistorialDeCargas";
import NuevoRegistroPlanSiembra from "./PlanSimebraComponents/NuevoRegistroPlanSiembra";
import { getUser } from "../../../utils/Common";
import VainillaDialogV2 from "../../../utils/VainillaDialogv2";
import { activeDialog } from "../../../utils/Common";

const formInit = Object.freeze({
  semana: "",
  florid: "0",
});

const PlanSiembra = (props) => {
  // -- usuario
  const [user, setUser] = useState(null);
  //const [semanas, setSemanas] = useState([]);
  const [section, setsection] = useState(-1);
  const [dialog, setdialog] = useState({ show: false });
  const profile = (getUser()?.perfil?.nombre ?? "").toUpperCase();

  useEffect(() => {
    initialData();
  }, []);

  const initialData = async () => {
    /* let resp = await Post("api/genPlanesData");
     if (!resp.estatus) {
       activeDialog(setdialog, resp.msj);
       return;
     }
     setSemanas(resp.data.semanas);*/
  }

  return (

    <div className="dosis" style={{ width: '100%', height: 'calc(100vh - 60px)' }}>
      <div className="col-lg-12 bg-white border round-m shadow-lg">
        <div className="border-b rounded-t p-2 bg-orange-800">
          <h5 className="font-bold uppercase text-white p-0">
            Plan de Siembra <span className="ms-2 text-s opacity-80">{user && `No. Semana Actual: ${user.noWeek[1]}`}</span>
          </h5>
        </div>

        <div className='row justify-content-center m-0 p-2 ps-3 pe-3'>
          <button className={`btn border btn-${section == 1 ? 'warning border-dark' : 'light shadow'} m-1 `} style={{ maxWidth: '200px' }} onClick={() => { setsection(1) }}>Consultar plan</button>
          <button className={`btn border btn-${section == 2 ? 'warning border-dark' : 'light shadow'} m-1 `} style={{ maxWidth: '200px' }} onClick={() => { setsection(2) }}>Agregar registros</button>
          <button className={`btn border btn-${section == 3 ? 'warning border-dark' : 'light shadow'} m-1 `} style={{ maxWidth: '200px' }} onClick={() => { setsection(3) }}>Cargar plan desde Excel</button>
          {['USUARIO', 'ADMINISTRADOR'].includes(profile) && <button className={`btn border btn-${section == 4 ? 'warning border-dark' : 'light shadow'} m-1 `} style={{ maxWidth: '200px' }} onClick={() => { setsection(4) }}>Historial de cargas</button>}
          {section === -1 && <>
            <div className='col-lg-10 p-3 m-5 shadow bg-light text-center '>
              <p className="text-l text-600 text-dark m-0 p-0">Verifique, agregue entradas y carge datos de documentos Excel para el plan de siembra</p>
              <p className="text-s text-300 text-dark opacity-90 m-0 p-0">Utilice los botones superiores para realizar diferentes actividades</p>
            </div>
          </>}

        </div>
        {section === 1 && <VerPlanSiembra />}
        {section === 2 && <NuevoRegistroPlanSiembra />}
        {section === 3 && <CargarExcel />}
        {['USUARIO', 'ADMINISTRADOR'].includes(profile) && section === 4 && <HistorialDeCargas />}

      </div>
      <VainillaDialogV2 data={dialog} />
    </div>

  );
};

export default PlanSiembra;